import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Navbar from "@/components/Navbar";
import { useT } from "@/lib/i18n";

export default function PaymentCancel() {
  const t = useT();
  return (
    <div className="min-h-screen bg-bone">
      <Navbar />
      <main className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="payment-cancel">
        <XCircle className="w-14 h-14 mx-auto text-terracotta" />
        <h1 className="mt-6 font-serif text-4xl text-forest font-bold">{t("payment_cancelled")}</h1>
        <p className="mt-2 text-charcoal/70">{t("basket_safe")}</p>
        <Link
          to="/checkout"
          className="inline-block mt-8 px-6 py-3 rounded-full"
          style={{ backgroundColor: "var(--forest)", color: "#F9F8F6" }}
          data-testid="retry-checkout-btn"
        >
          {t("retry_checkout")}
        </Link>
      </main>
    </div>
  );
}
